import { styled } from "stitches.config";
import Typography from "../sushi/Typography";
import { useIntl } from "react-intl";
import { getFormattedValue } from "@/utils/simulators";

export type CompoundInterestsResultValuesProps = {
    endCapital: number;
    payments: number;
    interests: number;
    isInvalid?: boolean;
}

export const CompoundInterestsResultValues = ({ endCapital, interests, payments, isInvalid }: CompoundInterestsResultValuesProps) => {
    const { formatMessage } = useIntl();

    return (
      <ResultValuesContainer>
        <div>
          <Typography variant="bodyS" color="secondary">
            {formatMessage({id: 'compound_interests_simulator.result.end_capital'})}
          </Typography>
          <Typography variant="headingS" color="primary">
            {getFormattedValue(endCapital, isInvalid)}
          </Typography>
        </div>
        <SubValuesContainer>
          <ValueContainer>
            <Typography variant="bodyS" color="secondary">
              {formatMessage({id: 'compound_interests_simulator.result.payments'})}
            </Typography>
            <Typography variant="bodyS" color="primary" weight="medium">
              {getFormattedValue(payments, isInvalid)}
            </Typography>
          </ValueContainer>
          <ValueContainer>
            <Typography variant="bodyS" color="secondary">
              {formatMessage({id: 'compound_interests_simulator.result.interests'})}
            </Typography>
            <Typography variant="bodyS" color="primary" weight="medium">
              {getFormattedValue(interests, isInvalid)}
            </Typography>
          </ValueContainer>
        </SubValuesContainer>
      </ResultValuesContainer>
    )
}

const ResultValuesContainer = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    gap: '$6',
  });

  const SubValuesContainer = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    gap: '$2',
    padding: '0 $10',
  });

  const ValueContainer = styled('div', {
    display: 'flex',
    flexDirection:' row',
    alignItems: 'center',
    justifyContent: 'space-between',
  });
